import { render, staticRenderFns } from "./SourceBreakdownChart.vue?vue&type=template&id=64f965e0&scoped=true&"
import script from "./SourceBreakdownChart.vue?vue&type=script&lang=js&"
export * from "./SourceBreakdownChart.vue?vue&type=script&lang=js&"
import style0 from "./SourceBreakdownChart.vue?vue&type=style&index=0&id=64f965e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f965e0",
  null
  
)

export default component.exports